import { twMerge } from "tailwind-merge";

export function Badge({ text, className }: { text: string; className?: string }) {
  return (
    <span className={twMerge(`inline-block outline text-xs font-semibold px-2.5 py-0.5 rounded-full whitespace-nowrap`, className)}>{text}</span>
  );
}
